import React, {useState} from "react";
import {useEffectOnce} from "../hooks/useEffectOnce";
import * as UserService from "../api/UserService";
import {
    CarouselLayout,
    ControlBar,
    LiveKitRoom,
    ParticipantTile,
    useTracks
} from "@livekit/components-react";
import {Track} from "livekit-client";

import lKScreenStyle from "./LKCallScreen.module.css"
import CustomRoomAudioRenderer from "./CustomRoomAudioRenderer.tsx"
import MusicNoteIcon from "./MusicNoteIcon";
import BackgroundMusic from "./BackgroundMusic";
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import HeightIcon from "@mui/icons-material/Height";


const serverUrl = 'wss://leelaonline-yry7yf2y.livekit.cloud';
function LKCallScreen(props) {

    const [lkToken, setLkToken] = useState()
    const [backgroundMusicFolded, setBackgroundMusicFolded] = useState(true)
    const [isHorizontal, setIsHorizontal] = useState(false)

    function handleErrorWithConfirm(error) {
        if (window.confirm(
            "Помилка в роботі відео \n"
            + JSON.stringify(error) + " [" + error.message + "]"
            + "\n\nПерезавантажте сторінку і спробуйте ще раз. "
            + "\nЯкщо проблема не зникне - повідомте в службу підтримки і змініть відео на альтернативне."
            + "\n\n Перезавантажити сторінку?"
        )) {
            window.location.reload()
        } else {
            props.onStop()
        }
    }

    function handleMediaDeviceErrorWithConfirm(reason) {
        if (window.confirm(
            "Помилка доступу до камери чи мікрофону"
            + "\n" + reason + ""
            + "\n\nПерезавантажте сторінку і спробуйте ще раз. "
            + "\nЯкщо проблема не зникне - переконайтесь в коректній роботі камери та мікрофону і що до них надано доступ"
            + "\n\nПерезавантажити сторінку?"
        )) {
            window.location.reload()
        } else {
            props.onStop()
        }
    }

    function MyVideoConference() {
        // `useTracks` returns all camera and screen share tracks. If a user
        // joins without a published camera track, a placeholder track is returned.
        const tracks = useTracks(
            [
                {source: Track.Source.Camera, withPlaceholder: true},
            ],
            {onlySubscribed: false},
        );


        return (
            <CarouselLayout
                tracks={tracks}
                orientation={isHorizontal && props.detached ? "horizontal" : "vertical"}
            >
                <ParticipantTile style={{width: props.detached ? "510px" : "270px", height: props.detached ? "340" : "180px"}}/>
            </CarouselLayout>
        );
    }

    function onLiveKitAuth(response) {
        setLkToken(response.token)
    }

    useEffectOnce(() => {
        UserService.getLiveKitToken(
            props.gameId,
            onLiveKitAuth,
            () => {
                window.alert("Failed to get LiveKit credentials")
            })
    })

    function handleDetach() {
        props.detachCallScreen()
    }

    return <LiveKitRoom
        video={{resolution: {width: 510, height: 340, frameRate: 25}}}
        audio={{echoCancellation: true, noiseSuppression: true}}
        token={lkToken}
        serverUrl={serverUrl}
        // Use the default LiveKit theme for nice styles.
        data-lk-theme="default"
        onDisconnected={props.onStop}
        onError={handleErrorWithConfirm}
        onMediaDeviceFailure={handleMediaDeviceErrorWithConfirm}
        style={{backgroundColor: "unset"}}
        participant={"true"}
    >

        {/* Your custom component with basic video conferencing functionality. */}
        <MyVideoConference detached={props.detached}/>
        {/* The RoomAudioRenderer takes care of room-wide audio for you. */}
        <CustomRoomAudioRenderer/>
        <div className={lKScreenStyle.detachIcon} onClick={handleDetach} onTouchStart={handleDetach}>
            {props.detached ? <CloseFullscreenIcon fontSize="small"/> : <OpenInFullIcon fontSize="small"/>}
        </div>
        {props.detached && <div className={lKScreenStyle.flipIcon} onClick={() => setIsHorizontal(!isHorizontal)} onTouchStart={() => setIsHorizontal(!isHorizontal)}>
            <HeightIcon
                className={ isHorizontal ? lKScreenStyle.flipped0 : lKScreenStyle.flipped90}
            />
        </div>}
        <ControlBar
            className={lKScreenStyle.controlButton}
            variation={"minimal"}
            controls={{chat: false, screenShare: false,}}
        />
        {props.isMentor && <div className={lKScreenStyle.musicIcon} onClick={() => setBackgroundMusicFolded(!backgroundMusicFolded)} onTouchStart={() => setBackgroundMusicFolded(!backgroundMusicFolded)}>
            <MusicNoteIcon/>
        </div>}

        <BackgroundMusic folded={backgroundMusicFolded}/>

    </LiveKitRoom>
}

export default React.memo(LKCallScreen)